var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.399 12.82a5.518 5.518 0 01-.056-.77c0-.545.112-.937.364-1.287.196-.28.434-.476 1.26-1.05.77-.546 1.022-.798 1.274-1.218.224-.392.336-.826.336-1.358 0-1.498-1.414-2.59-3.346-2.59-1.106 0-2.016.28-2.66.826-.574.476-.854.952-1.148 1.974l1.176.182c.154-.588.266-.854.504-1.162.462-.574 1.176-.882 2.086-.882 1.33 0 2.254.728 2.254 1.778 0 .42-.168.826-.49 1.162-.21.21-.448.406-.952.756-.812.56-.952.672-1.232 1.05-.364.49-.518.952-.518 1.68 0 .462 0 .574-.056.91h1.204zm-1.274 1.317v1.316h1.358v-1.316H9.125z",
    fill: "#fff"
  })));
}

export default SvgQuestionMark;